import LicenseTabs from './license-tabs';

const Licenses = () => {
  return (
    <div>
      <LicenseTabs />
    </div>
  );
};

export default Licenses;